import { IJSLComponent, IJSLVNode, refresh } from "jsl-render";
import { LoadingComponent } from "jsl-ui";
import { ExpertController } from "../../ajax/ExpertController";
import { CheckFundComponent } from "../components/CheckFundComponent";

export class CheckComponent implements IJSLComponent {

    private renderedData: CheckFundComponent[];

    constructor() {

        this.loadMore();

    }

    public render(): IJSLVNode {
        if (this.renderedData == null) {
            return <section class="banner-area">
                {new LoadingComponent()}
            </section>;
        }
        if (this.renderedData.length === 0) {
            return <section class="banner-area"><h3>Aktuell gibt es keine Funde die auf Freigabe warten :)</h3></section>;
        }
        if (this.renderedData._count((x) => !x.processed) === 0) {
            return <section class="banner-area"><button class="genric-btn primary" click={() => {
                this.loadMore();

            }}>weitere Funde laden</button></section>;
        }
        return <section class="banner-area">
            {this.renderedData}
        </section>;
    }

    private loadMore() {
        ExpertController.GetPendingFunde().then((data) => {
            this.renderedData = data.map((x) => new CheckFundComponent(x));
            // this.renderedData = [this.renderedData[0]];
            refresh();
        });
    }

}
